import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ProgressBar } from '../ui/ProgressBar';
interface LoadingPhaseProps {
  onComplete: () => void;
}
const messages = ['Sintonizando con el velo de tu karma...', 'Revelando los sellos de tu destino...', 'Tejiendo los hilos de tu pasado y futuro...', 'Consultando las antiguas tablillas...', 'Las tablillas han hablado. ¡Tu diagnóstico final está listo!'];
export const LoadingPhase = ({
  onComplete
}: LoadingPhaseProps) => {
  const [messageIndex, setMessageIndex] = useState(0);
  const [progress, setProgress] = useState(80);
  useEffect(() => {
    // Progress bar animation
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 99) {
          clearInterval(progressInterval);
          return 99;
        }
        return prev + 1;
      });
    }, 100); // 100ms * 20 steps = 2 seconds to reach 99%
    // Message rotation
    const messageInterval = setInterval(() => {
      setMessageIndex(prev => {
        if (prev === messages.length - 1) {
          clearInterval(messageInterval);
          setTimeout(onComplete, 2000); // Wait 2 seconds on final message before completing
          return prev;
        }
        return prev + 1;
      });
    }, 2500);
    return () => {
      clearInterval(progressInterval);
      clearInterval(messageInterval);
    };
  }, [onComplete]);
  return <div className="fixed inset-0 z-40 flex flex-col items-center justify-center bg-black/90 backdrop-blur-sm px-4" data-id="element-49">
      {/* Background particles/glow */}
      <motion.div className="absolute inset-0 opacity-30" animate={{
      background: ['radial-gradient(circle at 50% 50%, #b8860b22 0%, transparent 50%)', 'radial-gradient(circle at 50% 50%, #b8860b44 0%, transparent 60%)', 'radial-gradient(circle at 50% 50%, #b8860b22 0%, transparent 50%)']
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-50" />

      <div className="w-full max-w-md relative z-10 text-center" data-id="element-51">
        <motion.div animate={{
        rotate: 360
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: 'linear'
      }} className="w-24 h-24 mx-auto mb-12 border-2 border-dashed border-gold/50 rounded-full flex items-center justify-center" data-id="element-52">
          <div className="w-16 h-16 border border-gold rounded-full flex items-center justify-center" data-id="element-53">
            <div className="w-8 h-8 bg-gold/20 rounded-full animate-pulse" data-id="element-54" />
          </div>
        </motion.div>

        <h2 className="font-cinzel text-2xl text-gold mb-8 tracking-widest uppercase" data-id="element-55">
          Decodificando los Secretos
        </h2>

        <div className="h-16 mb-8" data-id="element-56">
          <AnimatePresence mode="wait" data-id="element-57">
            <motion.p key={messageIndex} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.5
          }} className="font-eb text-xl text-parchment italic" data-id="element-58">
              {messages[messageIndex]}
            </motion.p>
          </AnimatePresence>
        </div>

        <ProgressBar progress={progress} data-id="element-59" />
      </div>
    </div>;
};